import { Badge } from "../../../../components/ui/common/badge";
import { IngredientDataTypeLabel } from "../../../../config/enums/IngredientType.enum";
import { IngredientRowViewModel } from "../types/ingredientListView.types";

interface IngredientDataTypeBadgeProps {
  row: IngredientRowViewModel;
}

/**
 * Renders the "Data Type" pill. Keeps the existing `IngredientDataTypeLabel`
 * copy (Generic / Supplier / Calculated LCA) rather than the prototype's
 * wording, per the data-type semantics staying unchanged in this phase.
 */
const IngredientDataTypeBadge = ({ row }: IngredientDataTypeBadgeProps) => {
  const dataType = row.supplierIngredientDetails?.data_type as
    | keyof typeof IngredientDataTypeLabel
    | undefined;
  const label = dataType ? IngredientDataTypeLabel[dataType] : "";

  if (!label) {
    return null;
  }

  return (
    <Badge variant="outline" className="tw-rounded-full tw-text-xs tw-font-normal tw-text-foreground">
      {label}
    </Badge>
  );
};

export default IngredientDataTypeBadge;
